import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { DropdownMenu } from 'approot/shared/dropdown/dropdown.style';

export const ContentDropdown = styled.div`
  ${DropdownMenu} {
    max-height: ${rem(396)};
    min-width: ${rem(220)};
  }
`;
